<template>
    <div class="user-count" v-show="show">
        <div class="room-group">
            <div style="padding: 10px;">
                <div class="user-count-item">
                    <input-number v-model="guests.room" :min="1" :max="3"></input-number>
                    <span>{{$t('room')}}</span>
                </div>
            </div>
            <div class="middle-line">{{$t('guest_per_room')}}</div>
            <div style="padding: 10px">
                <div class="user-count-item">
                    <input-number v-model="guests.Adults" :min="1" :max="adult"></input-number>
                    <span>{{$t('adult')}}</span>
                </div>
                <div class="user-count-item">
                    <input-number
                        v-model="guests.Children"
                        @plus="plusAge(guests.Age)"
                        @minus="minusAge(guests.Age)"
                        :max="child"
                    ></input-number>
                    <span>{{guests.Children >= 2 ? $t('children') : $t('child')}}</span>
                </div>
                <div
                    class="room-group"
                    style="background-color: rgba(246,246,246,1);"
                    v-for="(i,id) in guests.Age"
                    :key="id"
                >
                    <div class="user-count-item">
                        <input-number v-model="i.Age" :min="0" :max="12" :selectIcon="false"></input-number>
                        <span>{{$t('age_name')}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InputNumber from "@/components/Inputnumber.vue";
import { mapGetters } from "vuex";
export default {
    // name: 'persionMenu',
    components: {
        InputNumber
    },
    watch: {
        "$store.getters.guests": {
            deep: true,
            immediate: true,
            handler: function(val) {
                this.$store.dispatch("updateGuests", val);
                this.$emit("i-select", val);
            }
        }
    },
    computed: {
        ...mapGetters(["guests"]),
        adult() {
            return 9 - this.$store.getters.guests.Children;
        },
        child() {
            return this.$store.getters.guests.Children < 5
                ? 9 - this.$store.getters.guests.Adults
                : 4;
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        //增加指定儿童的年龄
        plusAge(item) {
            item.length < this.child ? item.push({ Age: 8 }) : item;
        },
        //减少指定儿童的年龄
        minusAge(item) {
            item.length > 0 ? item.pop() : item;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../../sass/fonts/iconfont.css";
@import "../../../sass/variables";
.user-count {
    background: #ffffff;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26),
        0 2px 10px 0 rgba(0, 0, 0, 0.16);
    position: absolute;
    top: 60px;
    // bottom: 40px;
    left: 0;
    // right: 145px;
    // bottom: 90px;
    width: 240px;
    font-size: 14px;
    color: $black;
    z-index: 1;
    .user-count-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 32px;
    }
    .middle-line {
        background-color: #f0f0f0;
        color: #767676;
        font-size: 12px;
        line-height: 22px;
        padding-left: 10px;
    }
    em {
        font-style: normal;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/AirTicket/components/GuestsMenu.vue